function girls_date(girl_name_img,date_place){
    var data_girl_conf={
        "park":{
            "custom":{eye:{step_max:2,img:[1,2]},m:{step_max:3,img:[0,1,2,3]}}
        },
        "beach":{
            "custom":{eye:{step_max:2,img:[0,1,2]},m:{step_max:3,img:[0,1,2,3]}}
        },
        "resto":{
            "custom":{eye:{step_max:2,img:[0,1,2]},m:{step_max:3,img:[0,1,2,3]}}
        },
        "couch1":{
            "custom":{eye:{step_max:2,img:[0,1,2]},m:{step_max:3,img:[0,1,2,3]}}
        },
        "couch2":{
            "custom":{eye:{step_max:2,img:[0,1,2]},m:{step_max:3,img:[0,1,2,3]},
                anim_custom:{step_max:3,img:[1,2,3]}}
        },
        "couch3":{
            "custom":{
                eye:{step_max:2,img:[0,1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                girl:{step_max:1,img:[0,1],interval:1500, scene_range:[1,2]},
            }
        },
        "mass1":{
            "custom":{
                eye:{step_max:2,img:[0,1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "indira":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "zoe":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
        },
        "mass2":{
            "custom":{
                eye:{step_max:2,img:[0,1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "indira":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "zoe":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
        },
        "mass3":{
            "custom":{
                eye:{step_max:2,img:[0,1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "indira":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
            "zoe":{
                eye:{step_max:0,img:[]},
                m:{step_max:0,img:[]},
                anim:{step_max:2,img:[0,1,2],interval:200, scene_range:[1,2]}
            },
        },
        "police1":{
            "custom":{
                eye:{step_max:2,img:[1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                before:{clips:1,interval:500,loop:1,img:[0,1]}
            }
        },
        "police2":{
            "custom":{
                eye:{step_max:2,img:[1,2]},
                m:{step_max:3,img:[0,1,2,3]},
                anim_custom:{step_max:3,img:[1,2,3]}
            },
            anya:{
                m:{step_max:4,img:[0,1,2,3,4]}
            }
        },
        "police3":{
            "custom":{
                girl_none:1,
                anim_clip:{clips:27,width:600,interval:70,loop:1}
            },
            "maggie":{
                 add_preload:["/gfx/place/girls/date/police3/maggie.jpg"]
            },
            "winona":{
                 add_preload:["/gfx/place/girls/date/police3/winona.jpg"],
                 anim_clip:{clips:26,width:600,interval:70,loop:1}
            },
            "anya":{
                 add_preload:["/gfx/place/girls/date/police3/anya.jpg"],
                 anim_clip:{clips:27,width:600,interval:70,loop:1}
            },
            "linn":{
                 add_preload:["/gfx/place/girls/date/police3/linn.jpg"]
            }
        }
    };
    if(!date_place || typeof data_girl_conf[date_place]=="undefined"){
        return false;
    }
    var conf=copyObj(data_girl_conf[date_place]["custom"]);
    if(typeof data_girl_conf[date_place][girl_name_img]!="undefined"){
        conf=$.extend(conf,data_girl_conf[date_place][girl_name_img]);
    }
    var preload_arr=[],i,bum;
    if(typeof conf.eye!="undefined"){
        for(i in conf.eye.img){
           bum=conf.eye.img[i];
           preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/eye"+bum+".png");
       }
    }
    if(typeof conf.m!="undefined"){
        for(i in conf.m.img){
            bum=conf.m.img[i];
            preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/m"+bum+".png");
        }
    }
    if(typeof conf.anim!="undefined"){
        for(i in conf.anim.img){
            bum=conf.anim.img[i];
            preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/anim"+bum+".png");
        }
    }
    if(typeof conf.anim_custom!="undefined"){
        for(i in conf.anim_custom.img){
            bum=conf.anim_custom.img[i];
            preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/anim_custom/ready/a"+bum+".png");
        }
    }
    if(typeof conf.before!="undefined"){
        for(i in conf.before.img){
            bum=conf.before.img[i];
            preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/b"+bum+".png");
        }
    }
    if(typeof conf.add_preload!="undefined"){
        for(i in conf.add_preload){
            bum=conf.add_preload[i];
            preload_arr.push(""+_IMG_SERV+bum);
        }
    }
    if(typeof conf.girl!="undefined"){
        for(i in conf.girl.img){
            bum=conf.girl.img[i];
             preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/girl"+bum+".png");
        }
    }
    else if(typeof conf.girl_none=="undefined"){
        preload_arr.push(""+_IMG_SERV+"/gfx/place/girls/date/"+date_place+"/"+girl_name_img+"/ready/girl.png");
    }
    function startDateAnim(){
//        return false;
//        $.qLog("start");
        var bookDateBack=$(".place.girls .isDateBook.book .dateBackground"),
        eye_d=bookDateBack.find(".eye"),m_d=bookDateBack.find(".m");
        if(typeof conf.eye!="undefined"){
            eye_d.myEye({step_max:conf.eye.step_max});
        }
        if(typeof conf.m!="undefined"){
            m_d.myEye({step_max:conf.m.step_max});
        }
        if(typeof conf.anim_custom!="undefined"){
            bookDateBack.find(".anim_custom").myEye(conf.anim_custom);
        }
        if(typeof conf.girl!="undefined"){
            bookDateBack.find(".girl").myEye(conf.girl);
        }
        if(typeof conf.anim!="undefined"){
            bookDateBack.find(".anim").myEye(conf.anim);
        }
        if(typeof conf.before!="undefined"){
            bookDateBack.find(".before").qAnim(conf.before);
        }
        if(typeof conf.anim_clip!="undefined"){
            bookDateBack.find(".anim_clip").qAnim(conf.anim_clip);
        }
    }
    $("<div></div>").one("myload",function(){
            startDateAnim();
    }).myLoad(preload_arr);

}